import actionTypes from 'redux/actionTypes';

export function getReportsList(data) {
	return {
		type: actionTypes.GET_REPORTS_LIST,
		payload: data
	};
}

export function getReportsListSuccess(result) {
	return {
		type: actionTypes.GET_REPORTS_LIST_SUCCESS,
		payload: result
	};
}

export function getReportsListFailure(error) {
	return {
		type: actionTypes.GET_REPORTS_LIST_FAILURE,
		payload: error
	};
}

export function getSharedReportsList(data) {
	return {
		type: actionTypes.GET_SHARED_REPORTS_LIST,
		payload: data
	};
}

export function getSharedReportsListSuccess(result) {
	return {
		type: actionTypes.GET_SHARED_REPORTS_LIST_SUCCESS,
		payload: result
	};
}
export function getSharedReportsListFailure(error) {
	return {
		type: actionTypes.GET_SHARED_REPORTS_LIST_FAILURE,
		payload: error
	};
}

export function downloadReport(data) {
	return {
		type: actionTypes.DOWNLOAD_REPORT,
		payload: data
	};
}

export function downloadLargeReport(data) {
	return {
		type: actionTypes.DOWNLOAD_LARGE_REPORT,
		payload: data
	};
}

export function downloadReportSuccess(result) {
	return {
		type: actionTypes.DOWNLOAD_REPORT_SUCCESS,
		payload: result
	};
}

export function downloadLargeReportSuccess(result) {
	return {
		type: actionTypes.DOWNLOAD_LARGE_REPORT_SUCCESS,
		payload: result
	};
}
export function downloadReportFailure(error) {
	return {
		type: actionTypes.DOWNLOAD_REPORT_FAILURE,
		payload: error
	};
}
export function downloadLargeReportFailure(error) {
	return {
		type: actionTypes.DOWNLOAD_LARGE_REPORT_FAILURE,
		payload: error
	};
}
export function deleteReport(data) {
	return {
		type: actionTypes.DELETE_REPORT,
		payload: data
	};
}

export function deleteReportSuccess(result) {
	return {
		type: actionTypes.DELETE_REPORT_SUCCESS,
		payload: result
	};
}

export function deleteReportFailure(error) {
	return {
		type: actionTypes.DELETE_REPORT_FAILURE,
		payload: error
	};
}

export function refreshReportList(data) {
	return {
		type: actionTypes.REFRESH_REPORTS_LIST,
		payload: data
	};
}

export function refreshReportListSuccess(result) {
	return {
		type: actionTypes.REFRESH_REPORTS_LIST_SUCCESS,
		payload: result
	};
}

export function refreshReportListFailure(error) {
	return {
		type: actionTypes.REFRESH_REPORTS_LIST_FAILURE,
		payload: error
	};
}

export function initiateRunNow(data) {
	return {
		type: actionTypes.INITIATE_RUN_NOW,
		payload: data
	};
}

export function initiateRunNowSuccess(data) {
	return {
		type: actionTypes.INITIATE_RUN_NOW_SUCCESS,
		payload: data
	};
}

export function initiateRunNowFailure(error) {
	return {
		type: actionTypes.INITIATE_RUN_NOW_FAILURE,
		payload: error
	};
}

export function editReport(data) {
	return {
		type: actionTypes.EDIT_REPORT,
		payload: data
	};
}

export function setTabValue(data) {
	return {
		type: actionTypes.SET_TAB_VALUE,
		payload: data
	};
}

export function getUserList(data) {
	return {
		type: actionTypes.GET_USER_LIST,
		payload: data
	};
}

export function getUserListSuccess(data) {
	return {
		type: actionTypes.GET_USER_LIST_SUCCESS,
		payload: data
	};
}

export function getUserListFailure(error) {
	return {
		type: actionTypes.GET_USER_LIST_FAILURE,
		payload: error
	};
}

export function resetUsersWithReportAccess() {
	return {
		type: actionTypes.RESET_USERS_WITH_REPORT_ACCESS
	};
}

export function setInvitedUsers(data) {
	return {
		type: actionTypes.SET_INVITED_USERS,
		payload: data
	};
}

export function setUsersWithReportAccess(data) {
	return {
		type: actionTypes.SET_USERS_WITH_REPORT_ACCESS,
		payload: data
	};
}

export function setUsersWithReportAccessSuccess(data) {
	return {
		type: actionTypes.SET_USERS_WITH_REPORT_ACCESS_SUCCESS,
		payload: data
	};
}

export function setGrantUserAccessFailure(error) {
	return {
		type: actionTypes.SET_USERS_WITH_REPORT_ACCESS_FAILURE,
		payload: error
	};
}

export function removeReportAccess(data) {
	return {
		type: actionTypes.REMOVE_REPORT_ACCESS,
		payload: data
	};
}

export function removeReportAccessFailure(error) {
	return {
		type: actionTypes.REMOVE_REPORT_ACCESS_FAILURE,
		payload: error
	};
}

export function setUsersToRemoveAccess(data) {
	return {
		type: actionTypes.SET_USERS_TO_REMOVE_ACCESS,
		payload: data
	};
}

export function leaveReport(data) {
	return {
		type: actionTypes.LEAVE_REPORT,
		payload: data
	};
}

export function leaveReportSuccess(data) {
	return {
		type: actionTypes.LEAVE_REPORT_SUCCESS,
		payload: data
	};
}

export function leaveReportFailure(error) {
	return {
		type: actionTypes.LEAVE_REPORT_FAILURE,
		payload: error
	};
}

export function getMerchantUserList(data) {
	return {
		type: actionTypes.GET_MERCHANT_USER_LIST,
		payload: data
	};
}

export function merchantUserListSuccess(data) {
	return {
		type: actionTypes.GET_MERCHANT_USER_LIST_SUCCESS,
		payload: data
	};
}

export function merchantUserListFailure(error) {
	return {
		type: actionTypes.GET_MERCHANT_USER_LIST_FAILURE,
		payload: error
	};
}

export function getDVUserList(data) {
	return {
		type: actionTypes.GET_DV_USER_LIST,
		payload: data
	};
}

export function dvUserListSuccess(data) {
	return {
		type: actionTypes.GET_DV_USER_LIST_SUCCESS,
		payload: data
	};
}

export function dvUserListFailure(error) {
	return {
		type: actionTypes.GET_DV_USER_LIST_FAILURE,
		payload: error
	};
}

export function getSavedReportsList(data) {
	return {
		type: actionTypes.GET_SAVED_REPORTS_LIST,
		payload: data
	};
}

export function updateSavedReportsList(data) {
	return {
		type: actionTypes.UPDATE_SAVED_REPORTS_LIST,
		payload: data
	};
}

export function getSavedReportsListSuccess(data) {
	return {
		type: actionTypes.GET_SAVED_REPORTS_LIST_SUCCESS,
		payload: data
	};
}

export function getSavedReportsListFailure(error) {
	return {
		type: actionTypes.GET_SAVED_REPORTS_LIST_FAILURE,
		payload: error
	};
}

export function setReportTypeTabValue(data) {
	return {
		type: actionTypes.SET_REPORT_TYPE_TAB_VALUE,
		payload: data
	};
}

export function setReportListFilterValues(payload) {
	return {
		type: actionTypes.SET_REPORT_LIST_FILTER_VALUES,
		payload
	};
}

export function dbSearchTxt(payload) {
	return {
		type: actionTypes.SEARCH_TXT,
		payload
	};
}
export function dbSortBy(payload) {
	return {
		type: actionTypes.SORTBY,
		payload
	};
}
export function dbSortDirection(payload) {
	return {
		type: actionTypes.SORT_DIRECTION,
		payload
	};
}
export function dbFilterBy(payload) {
	return {
		type: actionTypes.FILTER_BY,
		payload
	};
}

export function dbResetFilter() {
	return {
		type: actionTypes.RESET_DASHBOARD_FILTER
	};
}

export function setSharedReportTabValue(data) {
	return {
		type: actionTypes.SET_SHARED_TAB_VALUE,
		payload: data
	};
}

export function getReportStartAndEndDates(data) {
	return {
		type: actionTypes.GET_START_AND_END_DATES,
		payload: data
	};
}

export function getReportStartAndEndDatesSuccess(data) {
	return {
		type: actionTypes.GET_START_AND_END_DATES_SUCCESS,
		payload: data
	};
}

export function getReportStartAndEndDatesFailure() {
	return {
		type: actionTypes.GET_START_AND_END_DATES_FAILURE
	};
}
